import { ANALYTICS_PARAM_VALUE_MAX_LENGTH } from '@/constants/analytics';

export type ContactPickerSource = 'recording_flow' | 'meeting_detail';

export type ContactPickerCloseAction = 'skip' | 'cancel' | 'backdrop' | 'attach_contact';

export interface ContactPickerAnalyticsContext {
  readonly meetingId: string;
  readonly source: ContactPickerSource;
  readonly recordingSessionId: string | null;
}

// Firebase rejects array params (error 21) and caps string values, so ids go comma-joined and trimmed.
export const formatContactIdsParam = (contactIds: readonly number[]): string =>
  contactIds.map(String).join(',').slice(0, ANALYTICS_PARAM_VALUE_MAX_LENGTH);
